import { isCoworkerPreferences } from '@repo/types/coworker-preferences';
import { fetcher } from '@repo/utils';

export const getCoworkerPreferences = async (basePath: string) => {
    const req = await fetcher(basePath);
    const data = await req.json();

    if (!isCoworkerPreferences(data)) {
        throw new Error('Coworker preferences response did not include buCode');
    }

    return data;
};
